export const eliteStr = [
  { imageName: "精英_0_大图.png", label: "精英0" },
  { imageName: "精英_1_大图.png", label: "精英1" },
  { imageName: "精英_2_大图.png", label: "精英2" },
];
